import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { userPendingFundsBackend } from './user-pending-funds.backend';
import { userPendingFundsReducer } from './user-pending-funds.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('userPendingFunds', userPendingFundsReducer),
    BackendModule.forFeature('userPendingFunds', userPendingFundsBackend),
  ],
})
export class DatastoreUserPendingFundsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-pending-funds/user-pending-funds.module.ts